export default "__VITE_ASSET__BeXVmj13__"